import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { PqrReceivedThroughDataProps } from './props';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { Param } from '../../../../../../shared/types/param';
import {
    asyncGetLastCodeSuffixParam,
    asyncGetParams,
} from '../../../../../../services/param.service';
import { useParams } from 'react-router-dom';

export const usePqrReceivedThroughData = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrReceivedThroughDataProps) => {
    const [newCode, setNewCode] = useState<string>('');
    const [types, setTypes] = useState<ISelect[]>([]);

    const { idReceivedThrough } = useParams();
    const onSubmit = (data: Param) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(idReceivedThrough),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('code', data?.code || newCode);
        formik?.setFieldValue('class', data?.class || ParamEnum.PQR_HALF);
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active ?? true);
        formik?.setFieldValue('extra2', data?.extra2 || '');
        formik?.setFieldValue('parent', (data?.parent as ISelect)?.id || '');
    }, [data, newCode]);

    useEffect(() => {
        asyncGetLastCodeSuffixParam(ParamEnum.PQR_HALF).then((res: any) => {
            setNewCode(res?.items);
        });
    }, [newCode]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_TYPE).then((items) => setTypes(items));
    }, []);

    return {
        formik,
        types,
    };
};
